import React from 'react';
import { useDialog } from '../context/DialogContext';
import ConfirmDialog from './ConfirmDialog';
import AlertDialog from './AlertDialog';
import HelpDialog from './HelpDialog';

const DialogManager: React.FC = () => {
  const { dialogState, closeDialog } = useDialog();

  if (!dialogState.isOpen) return null;

  const handleConfirm = () => {
    if (dialogState.onConfirm) {
      dialogState.onConfirm();
    }
    closeDialog();
  };

  const handleCancel = () => {
    if (dialogState.onCancel) {
      dialogState.onCancel();
    }
    closeDialog();
  };

  switch (dialogState.type) {
    case 'confirm':
      return (
        <ConfirmDialog
          isOpen={dialogState.isOpen}
          onClose={handleCancel}
          onConfirm={handleConfirm}
          title={dialogState.title}
          message={dialogState.message || ''}
          confirmText={dialogState.confirmText}
          cancelText={dialogState.cancelText}
          variant={dialogState.variant}
        />
      );

    case 'alert':
      return (
        <AlertDialog
          isOpen={dialogState.isOpen}
          onClose={handleCancel}
          title={dialogState.title}
          message={dialogState.message || ''}
          okText={dialogState.okText}
          variant={dialogState.variant}
        />
      );

    case 'help':
      return (
        <HelpDialog
          isOpen={dialogState.isOpen}
          onClose={handleCancel}
          title={dialogState.title}
          content={dialogState.content || ''}
          maxWidth={dialogState.maxWidth}
          maxHeight={dialogState.maxHeight}
        />
      );

    default:
      return null;
  }
};

export default DialogManager; 